import Settings from 'configs/Settings';

const MAX_USER_NAME_DISPLAY = 2;
const MAX_NOTIFICATION_PER_PAGE = 10;

const NOTIFICATION_TYPE = {
  NORMAL: 'notifications',
  UNREAD: 'unreadNotifications'
};

const EVENT_TYPE = {
  AREA_COMMUNITY_EVENT: 'AREA_COMMUNITY_EVENT',
  COMMENT: 'COMMENT',
  LIKE: 'LIKE',
  PLACEHOLDER: 'PLACEHOLDER',
  REPLY: 'REPLY'
};

const COOKIE_NAME = 'hmClubNotification';
const FIREBASE_CONFIG = { ...Settings.firebaseConfig };

export {
  MAX_USER_NAME_DISPLAY,
  MAX_NOTIFICATION_PER_PAGE,
  NOTIFICATION_TYPE,
  EVENT_TYPE,
  COOKIE_NAME,
  FIREBASE_CONFIG
};
